(function () {
  'use strict';

  angular
    .module('traineeWebApp.dashboard').component('traineeAppSwitcher', {
      templateUrl: 'components/appSwitcher.component.html',
      controller: traineeAppSwitcherCtrl,
      bindings: {}
    });

  traineeAppSwitcherCtrl.$inject = ['dashboardResource', 'mtypes', '$window'];

  function traineeAppSwitcherCtrl(dashboardResource, mtypes, $window) {
    var ctrl = this;

    ctrl.mfConfig = $window.mfConfig;

    var APP_TYPE_MAP = new CustomMap();
    APP_TYPE_MAP.set(mtypes.consoleAppType.trakstarConsole, 'trakstar_console');
    APP_TYPE_MAP.set(mtypes.consoleAppType.trakstarHire, 'trakstar_hire');
    APP_TYPE_MAP.set(mtypes.consoleAppType.trakstarLearn, 'trakstar_learn');
    APP_TYPE_MAP.set(mtypes.consoleAppType.trakstarPerform, 'trakstar_perform');

    var consoleApp = {
      appType: mtypes.consoleAppType.trakstarConsole,
      currentApp: false,
      logoName: 'ts-console-logo.png',
      desc: 'Manage user records for all your Trakstar apps in one place',
      shortDesc: 'Centralized User Records',
    };

    var availableApps = [
      {
        appType: mtypes.consoleAppType.trakstarHire,
        currentApp: false,
        logoName: 'ts-hire-logo.png',
        desc: 'Simplify your hiring process by posting jobs, reviewing candidates, and collaborating online',
        shortDesc: 'Recruiting & Hiring',
      },
      {
        appType: mtypes.consoleAppType.trakstarLearn,
        currentApp: true,
        logoName: 'ts-learn-logo.png',
        desc: 'Streamline employee learning with accessible courses for onboarding, compliance, and more',
        shortDesc: 'Training & Development',
      },
      {
        appType: mtypes.consoleAppType.trakstarPerform,
        currentApp: false,
        logoName: 'ts-perform-logo.png',
        desc: 'Modernize performance management with easy to use reviews, feedback, and goals',
        shortDesc: 'Performance & Engagement',
      },
    ];

    ctrl.appSwitcherVisible = false;

    ctrl.consoleCustomerId = 0;
    ctrl.enabledApps = [];
    ctrl.disabledApps = [];

    ctrl.toggleAppSwitcher = function () {
      ctrl.appSwitcherVisible = !ctrl.appSwitcherVisible;
    }

    ctrl.$onInit = function () {
      dashboardResource.getUserAppInfo().then(function (appsInfo) {
        // Reset lists
        ctrl.enabledApps = [];
        ctrl.disabledApps = [];

        ctrl.appSwitcherUrl = ctrl.mfConfig.consoleIntegration.appSwitcherUri;
        ctrl.platformMarketingPage = ctrl.mfConfig.trakstarPlatformMarketingPage;

        var appsAccessMap = {};
        appsInfo.apps.forEach(function (app) {
          // Set customer id from user apps info
          if (!ctrl.consoleCustomerId && app.appClientId) {
            ctrl.consoleCustomerId = app.appClientId;
          }
          appsAccessMap[app.appType] = app;
        });

        availableApps.forEach(function (app) {
          var appAccessDetail = appsAccessMap[app.appType];
          app.marketingPageUrl = ctrl.platformMarketingPage || '';
          app.productPageUrl = '';
          if (appAccessDetail) {
            app.productPageUrl = ctrl.productPageUrl(app);
            ctrl.enabledApps.push(app);
          }
          else if (app.currentApp) {
            app.productPageUrl = '';
            ctrl.enabledApps.push(app);
          }
          else {
            ctrl.disabledApps.push(app);
          }
        });

        // Adjust 'Switch App' section based on the number of enabled apps
        if (ctrl.enabledApps.length > 1) {
          // If more than one app is enabled - add console app to the 'Switch App' section
          consoleApp.productPageUrl = ctrl.productPageUrl(consoleApp);
          ctrl.enabledApps.push(consoleApp);
        }
        else {
          // If only one app is enabled - don't show anything in 'Switch App' section
          ctrl.enabledApps = [];
        }
      });
    }

    ctrl.productPageUrl = function (app) {
      if (app.currentApp || !ctrl.consoleCustomerId) {
        return '';
      }

      var url = ctrl.appSwitcherUrl + '?cus_id=' + ctrl.consoleCustomerId + '&app_type=' + APP_TYPE_MAP.get(app.appType);
      return url;
    }
  }

  var CustomMap = function () {
    this.set = function (key, value) {
      this[key] = value;
    }
    this.get = function (key) {
      return this[key];
    }
  }
})();
